

import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SaveButton extends Vue {
  @Prop({ default: () => Vue.prototype.$gettext('Save') }) tooltip!: string
  @Prop({ default: false }) disabled!: boolean
}
